import { useMemo } from 'react';
import styles from './styles/sharedPolicies.scss';
import Back from 'components/back';
import { IInvitation, IPolicy } from 'types';
import PoliciesContainer from '../policies/PoliciesContainer';
import PolicyDetails from 'containers/policy-details';

interface IProps {
  currentFamilyId: string;
  invitations: IInvitation[];
  selectedPolicy: IPolicy;
  setOwnedFamily(): void;
  getInvitationsByUserId(id: string): void;
  selectPolicy(policy: IPolicy): void;
}

const SharedWithMe = ({
  currentFamilyId,
  invitations,
  selectedPolicy,
  setOwnedFamily,
  selectPolicy,
}: IProps) => {
  const handleBack = () => {
    if (selectedPolicy) {
      selectPolicy(null);
    } else {
      setOwnedFamily();
    }
  };

  const selectedInvitation = useMemo(
    () => invitations.find(R.propEq('sk', currentFamilyId)) || ({} as any),
    [invitations, currentFamilyId],
  );

  const name = selectedInvitation?.ownerName
    ? `${selectedInvitation?.ownerName}'s`
    : 'Shared';

  const handlePolicyClick = (policy: IPolicy) => selectPolicy(policy);

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.header}>
        <div className={styles.dashboardBtns}>
          <Back className={styles.dashboardBack} handleBack={handleBack} />
        </div>
        <div className={styles.nameContainer}>
          <div
            className={styles.name}
          >{`Currently viewing ${name} policies`}</div>
          <div className={styles.subText}>(VIEW ONLY)</div>
        </div>
      </div>
      {selectedPolicy ? (
        <PolicyDetails hideBack={true} />
      ) : (
        <PoliciesContainer ownerName={name} onPolicyClick={handlePolicyClick} />
      )}
    </div>
  );
};

export default SharedWithMe;
